import { COLORS, CORNERS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const ILLUSTRATION_SIZE = {
  height: 182,
  width: 146,
};
export const IA_ICON_SIZE = { size: 24 };

const styleSheet = createStyleSheet({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: COLORS.WHITE.DEFAULT,
    borderRadius: CORNERS.CORNER4,
  },
  promptContainer: {
    flex: 1,
    padding: '32px 32px 40px 32px',
    height: '100%',
    width: '100%',
  },
  illustrationContainer: {
    position: 'absolute',
  },
  topContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '10px',
    width: '100%',
    marginBottom: '32px',
  },
  iaIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50px',
    width: '50px',
    background: 'linear-gradient(90deg, #348FFC 0%, #9747FF 100%)',
    borderRadius: '50px',
  },
  title: {
    ...TYPOGRAPHY.TITAN_L_SEMIBOLD,
  },
  UTag: {
    ...TYPOGRAPHY.CAPTION,
    fontWeight: 700,
    fontSize: '11px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 10px',
    borderRadius: '15px',
    background: 'linear-gradient(90deg, #348FFC 0%, #9747FF 100%)',
    color: COLORS.WHITE.DEFAULT,
  },

  middleContainer: {
    display: 'flex',
    position: 'relative',
    padding: '0px 15.5px',
    margin: '0 0 28px 0',
    zIndex: 2,
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    height: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px 0 0 0',
    margin: '0 0 0 0',
  },

  actionButtonChildrenEnabled: {
    color: COLORS.WHITE.DEFAULT,
  },
  actionButtonChildrenDisabled: {
    color: COLORS.DISABLED.DEFAULT,
  },
  actionButtonActive: {
    color: COLORS.WHITE.DEFAULT,
    background: 'linear-gradient(90deg, #348FFC 0%, #9747FF 100%)',
  },
  actionButtonActiveHovered: {
    color: COLORS.WHITE.DEFAULT,
    background: 'linear-gradient(90deg, #9747FF 0%, #348FFC 100%)',
  },
  footerCounterText: {
    ...TYPOGRAPHY.BODY3_SEMIBOLD,
    color: COLORS.DISABLED.DEFAULT,
  },
});

export default styleSheet;
